<script>

  import RemoteImage from "./ImageComponentVariants/RemoteImage.svelte";

  export let storyframeData;

  function firstImages() {
    let images = storyframeData['mediaURLs'].slice(0,3)
    if (images.length > 0) {
      return images
    } else {
      return null
    }
  }
</script>

<main>
  <media>
    {#each firstImages() as image }
      <RemoteImage name={image} />
    {/each}
  </media>
</main>

<style>
  main {
    width: 94%;
    height: 100%;
    background-color: rgb(30,30,45);
    box-shadow: 0 9px 10px -4px #272d35;
    border-radius: 4px;
    border-left: solid 2px black;
    border-bottom: solid 2px black;
    border-top: solid 1px black;
    border-right: solid 2px black;
  }

  media {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  @media screen and (max-width: 1200px){
    media {
      flex-direction: row;
      align-items: center;
    }
  }
</style>
